import { render, staticRenderFns } from "./MainNavbarUserName.vue?vue&type=template&id=02b45b8a"
import script from "./MainNavbarUserName.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavbarUserName.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports